import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { api, formatApiErrorDetail } from "@/lib/api";
import CancelReasonPicker from "@/components/plus/CancelReasonPicker";

export default function CancelFeedback() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const token = params.get("t") || "";
  const [state, setState] = useState("loading");
  const [code, setCode] = useState("");
  const [text, setText] = useState("");
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get("/feedback/cancellation", { params: { t: token } }).then(() => setState("form")).catch(() => setState("invalid"));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    try { await api.post("/feedback/cancellation", { token, reason_code: code, reason_text: text.trim() }); setState("done"); }
    catch (ex) { setErr(formatApiErrorDetail(ex.response?.data?.detail)); }
  };

  return (
    <div className="min-h-screen bg-bg flex items-center justify-center p-4">
      <div className="card-c w-full max-w-md space-y-4" data-testid="cancel-feedback-page">
        <Link to="/" className="font-display text-2xl text-primary-c">Oresto</Link>
        {state === "loading" && <p className="text-sm text-text-secondary">…</p>}
        {state === "invalid" && <p className="text-sm text-red-700" data-testid="cancel-feedback-invalid">{t("cancel.fb_invalid")}</p>}
        {state === "done" && <p className="text-sm" data-testid="cancel-feedback-done">{t("cancel.fb_thanks")}</p>}
        {state === "form" && (
          <form onSubmit={submit} className="space-y-3">
            <h1 className="font-display text-2xl">{t("cancel.fb_title")}</h1>
            <CancelReasonPicker code={code} text={text} onCode={setCode} onText={setText} withNoAnswer={false} prefix="fb-reason" />
            {err && <p className="text-sm text-red-700" data-testid="cancel-feedback-error">{err}</p>}
            <button disabled={!code || (code === "other" && !text.trim())} className="btn-primary w-full" data-testid="cancel-feedback-submit">{t("cancel.fb_send")}</button>
          </form>
        )}
      </div>
    </div>
  );
}
